// export const formatCurrency = (amount) => {
//   if (amount == null || amount === '') return '₦0.00';

//   // Convert to number safely: remove commas, spaces, and symbols
//   const numericAmount = parseFloat(String(amount).replace(/[^0-9.-]+/g, ''));

//   // Handle invalid number
//   if (isNaN(numericAmount)) return '₦0.00';

//   return new Intl.NumberFormat('en-NG', {
//     style: 'currency',
//     currency: 'NGN',
//   }).format(numericAmount);
// };
export const formatCurrency = (amount) => {
  if (amount == null || amount === '') return '₦0';

  // Convert to number safely: remove commas, spaces, and symbols
  const numericAmount = parseFloat(String(amount).replace(/[^0-9.-]+/g, ''));

  // Handle invalid number
  if (isNaN(numericAmount)) return '₦0';

  const formatted = new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numericAmount);

  // Remove trailing ".00" if present
  return formatted.replace(/\.00$/, '');
};
